import React, { Component } from "react";
import Container from "../common/application_container";
import Tabs from "react-responsive-tabs";
import { withRouter } from "react-router-dom";
import GatewayTable from "./components/gatewayTable";
import RestrictionTable from "./components/userRestriction.js/restrictionTable";
import RateDeckTable from "./components/ratedeck/rateDeckTable";
import CarrierInformation from "./carrierInformation";
import CarrierStirShakenSubjectBlock from "./components/stirShakenSubject/carrierStirShakenSubjectBlock";
import CarrierCallRestriction from "./carrierCallRestriction";

class ComponentTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      name: this.props.match.params.name,
    };
  }

  getTabs() {
    console.log("this.state.name :>> ", this.state.name);
    const tabItemList = [
      {
        name: "Carrier Information",
        biography: <CarrierInformation userId={this.state.id} />,
      },
      {
        name: "Gateways",
        biography: (
          <GatewayTable userId={this.state.id} linkName={this.state.name} />
        ),
      },
      {
        name: "User Restriction",
        biography: <RestrictionTable userId={this.state.id} />,
      },
      {
        name: "RateDeck",
        biography: <RateDeckTable userId={this.state.id} />,
      },
      {
        name: "Stir Shaken Subject Block",
        biography: (
          <CarrierStirShakenSubjectBlock
            userId={this.state.id}
            accountName={this.state.name}
          />
        ),
      },
      {
        name: "Call Restriction",
        biography: <CarrierCallRestriction userId={this.state.id} />,
      },
    ];
    return tabItemList.map((president, index) => ({
      title: president.name,
      getContent: () => president.biography,
      /* Optional parameters */
      key: index,
      tabClassName: "tab",
      panelClassName: "panel",
    }));
  }

  render() {
    const { name } = this.state;
    return (
      <Container
        title={name.toUpperCase() + " Carrier"}
        title1="Information"
        icon="icon-lan"
      >
        <Tabs items={this.getTabs()} />
      </Container>
    );
  }
}
export default withRouter(ComponentTabs);
